"use client";

import { c as _c } from "react/compiler-runtime";
import Alert from "./Alert";
export default function NotFoundContent(t0) {
  const $ = _c(33);
  const {
    title,
    description,
    pageTitle,
    backControl,
    action,
    actionLabel,
    favouriteRemoved: t1,
    stopAlerts: t2
  } = t0;
  const favouriteRemoved = t1 === undefined ? false : t1;
  let t3;
  if ($[0] !== t2) {
    t3 = t2 === undefined ? [] : t2;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const stopAlerts = t3;
  let t4;
  if ($[2] !== backControl) {
    t4 = <div className="row sticky top-0 z-20 mb-2 flex justify-between bg-white px-[20px] pb-2 pt-4 dark:bg-black">{backControl}</div>;
    $[2] = backControl;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== title) {
    t5 = <h1 className="mb-4 text-pretty text-3xl font-semibold" suppressHydrationWarning={true}>{title}</h1>;
    $[4] = title;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const t6 = stopAlerts.length > 0 && " Service alerts for this stop are shown below.";
  let t7;
  if ($[6] !== description || $[7] !== t6) {
    t7 = <p className="mb-8 text-lg" suppressHydrationWarning={true}>{description}{t6}</p>;
    $[6] = description;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const t8 = action || undefined;
  const t9 = `w-full rounded-full bg-blue-500 px-4 py-2 font-semibold text-white ring-blue-500/50 focus:outline-none focus-visible:ring sm:w-auto ${action ? "" : "hidden"}`;
  const t10 = !action;
  const t11 = action ? undefined : -1;
  let t12;
  if ($[9] !== actionLabel || $[10] !== t10 || $[11] !== t11 || $[12] !== t8 || $[13] !== t9) {
    t12 = <button type="button" onClick={t8} className={t9} aria-hidden={t10} suppressHydrationWarning={true} tabIndex={t11}>{actionLabel}</button>;
    $[9] = actionLabel;
    $[10] = t10;
    $[11] = t11;
    $[12] = t8;
    $[13] = t9;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] !== favouriteRemoved) {
    t13 = favouriteRemoved && <p role="status" className="mt-4">Removed from favourites.</p>;
    $[15] = favouriteRemoved;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] !== t12 || $[18] !== t13) {
    t14 = <div suppressHydrationWarning={true}>{t12}{t13}</div>;
    $[17] = t12;
    $[18] = t13;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] !== t14 || $[21] !== t5 || $[22] !== t7) {
    t15 = <div className="px-[20px]">{t5}{t7}{t14}</div>;
    $[20] = t14;
    $[21] = t5;
    $[22] = t7;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] !== stopAlerts) {
    t16 = stopAlerts.length > 0 && <section aria-label="Service alerts" className="mt-8 space-y-3 pb-8">{stopAlerts.map(_temp)}</section>;
    $[24] = stopAlerts;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== pageTitle) {
    t17 = <span className="sr-only" suppressHydrationWarning={true}>{pageTitle}</span>;
    $[26] = pageTitle;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  let t18;
  if ($[28] !== t15 || $[29] !== t16 || $[30] !== t17 || $[31] !== t4) {
    t18 = <div className="min-h-screen bg-white font-body text-zinc-900 antialiased dark:bg-black dark:text-white">{t4}{t15}{t16}{t17}</div>;
    $[28] = t15;
    $[29] = t16;
    $[30] = t17;
    $[31] = t4;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  return t18;
}
function _temp(alert, index) {
  return <Alert key={alert.alert_id ?? index} {...alert} />;
}